const eventBus = require('../../utils/EventBus');
const { UPDATE_SELECTED_EXAM_TYPE } = require('../../events');

module.exports = ({ id }) => {
  eventBus.fire(UPDATE_SELECTED_EXAM_TYPE, {
    examTypeId: id,
  });
};
